import React, { useState, useEffect } from 'react';

import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { hasAnyError } from '../helpers';
import { useFilterCount } from '../hooks';

export const TrackIdsInputPopover = ({ onCountChange = undefined }) => {
  const { register, formState: { errors }, setValue } = useFormContext();
  const { t } = useTranslation();
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(hasAnyError(errors, 'track_ids'));
  }, [errors, errors.track_ids]);

  const trackIds = useWatch({ name: 'track_ids' });
  const filterCount = trackIds ? 1 : 0;
  useFilterCount('track_ids', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasError={hasError}
      hasFilterValue={Boolean(filterCount)}
      testId="trackIdsFilter"
      triggerValue={t('идентификаторы треков')}
    >
      <Control.Input
        id="track_ids"
        label={t('идентификаторы треков через запятую')}
        {...register('track_ids', {
          validate: validate.multipleTrackIds(),
        })}
        errors={errors}
        isClearable
        onClear={() => setValue('track_ids', '')}
      />
    </CustomFilterPopover>
  );
};
